var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('eventi-list-component',{key:_vm.keyListaEventi,attrs:{"titoloEvento":_vm.titoloEvento,"gruppo":'MEDICINADELLOSPORT',"utente":_vm.utente,"pathEventResource":_vm.pathEventResource,"linkEvent":_vm.linkEvent,"tipoEvento":"IDONEITA"}})}
var staticRenderFns = []

export { render, staticRenderFns }